/**
 * Formats a 0 to 5 rating for display: clamped to that range, one decimal place,
 * with a trailing `.0` removed so a whole rating reads as "4" rather than "4.0".
 *
 * Shared because more than one component shows a rating and they must agree on
 * the rounding: the pill on the partner page and the star in the product card.
 */
export function formatRating(rating: number): string {
  const clamped = Math.min(5, Math.max(0, rating));
  const formatted = clamped.toFixed(1);
  return formatted.endsWith('.0') ? formatted.slice(0, -2) : formatted;
}
